import { ShowDate } from 'framework/ui/ui-builder';
import { TextField } from 'framework/ui/field';
import { useShowContext } from 'framework/show';
import { LEAD_CONVERSION_STATUS } from 'domain/sales/lead/shared/leadService';
import { DATE_FORMAT } from 'framework/utils';

const ConversionField = () => {
  const { data } = useShowContext();

  const date = <ShowDate dateUTC={data.getValueBySource('conversionTime')} format={DATE_FORMAT.FULL} />;

  let message;

  switch (data.getValueBySource('conversionStatus')) {
    case LEAD_CONVERSION_STATUS.CONVERSION_DONE:
      message = (
        <>
          Sent successfully to Google Ads (conversionName= `{data.getValueBySource('conversionName')}`, conversionTime=`
          {date}`)
        </>
      );
      break;
    case LEAD_CONVERSION_STATUS.CONVERSION_FAILED:
      message = (
        <>
          Conversion submission to Google Ads FAILED on {date}. Error: {data.getValueBySource('conversionError')}
        </>
      );
      break;
    default:
      message = null;
  }
  return <TextField label="Conversion" value={message} />;
};

export default ConversionField;
